import { V2L1AppHeaderNavTab } from './V2L1AppHeaderNavTab'
import { FormPage } from '@fusion-advantage/formlib'

interface V2L3FormAppHeaderNavProps {
	pages: FormPage[]
	activeIdx: number
	onChange?: (idx: number) => void
}

export const V2L3FormAppHeaderNavItems = ({pages, activeIdx, onChange = () => null}: V2L3FormAppHeaderNavProps) => {
	return (
		<>
			{pages.map(({title, icon}, idx) => (
				<V2L1AppHeaderNavTab
					key={idx}
					icon={icon}
					label={title}
					active={activeIdx === idx}
					onClick={() => onChange(idx)}
				/>
			))}
		</>
	)
}
